import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f6302b78")

_pushScopeId("data-v-f6302b78")
const _hoisted_1 = { class: "border-gray-lp-1400 border rounded-xl p-3" }
const _hoisted_2 = { class: "items-center mb-1 text-gray-lp-300 text-20px font-bold" }
const _hoisted_3 = { class: "text-14px font-normal font-montserrat text-gray-lp-600" }
const _hoisted_4 = { style: {"width":"100.6%"} }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "flex flex-row justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    width: "w-10/20",
    title: _ctx.$t('clientManagement.changeInsuranceModal.title'),
    onClose: () => _ctx.onHidePopup(),
    scrollable: false,
    isRounded: false,
    titlePadding: "px-6 py-3",
    contentPadding: "px-3 py-3",
    footerPadding: "px-6 py-3"
  }, {
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.insurance")), 1),
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("clientManagement.changeInsuranceModal.periodHint")), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Select, {
            id: "select_insurance_modal_update_insurance_client_parent",
            onOpenSelect: _ctx.onOpenSelectInsurance,
            onCloseSelect: _ctx.onCloseSelectInsurance,
            isOpenMenu: _ctx.isOpenSelectInsurance,
            value: _ctx.modelValue.insurance,
            onChooseSelect: _ctx.onSelectInsurance,
            dataSelect: _ctx.insurances,
            class: "whitespace-no-wrap my-3 z-10",
            placeholder: _ctx.$t('clientManagement.changeInsuranceModal.selectInsuranceType'),
            isShowDefault: false
          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "placeholder"])
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.modelValue.insurance === 'custom')
            ? (_openBlock(), _createBlock(_component_lp_input, {
                key: 0,
                modelValue: _ctx.modelValue.customRates,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.customRates = $event)),
                error: _ctx.error.customRates,
                onChange: _ctx.validateCustomRates,
                errorCaption: _ctx.errorCaptionCustomRates,
                placeholder: _ctx.$t('clientManagement.changeInsuranceModal.customRatesPlaceholder'),
                min: "2",
                max: "99",
                suffix: "%",
                isErrorIconInput: false,
                type: "number",
                isFloatingPrefixNumber: ""
              }, null, 8, ["modelValue", "error", "onChange", "errorCaption", "placeholder"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_LpButton, {
          title: _ctx.$t('clientManagement.infoPriceClient.save'),
          textColor: "white",
          disabled: !_ctx.isValidChangeInsurance,
          onClick: _ctx.onSaveInsurance,
          customClass: "px-4 py-2"
        }, null, 8, ["title", "disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
})